import React from "react";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { Check, ArrowRight, Sparkles } from "lucide-react";
import Reveal from "@/components/Reveal";
import FinalCTA from "@/components/FinalCTA";
import BrochureCTA from "@/components/BrochureCTA";
import { PACKAGES } from "@/data/content";
import { trackEvent, EVENTS } from "@/utils/tracking";
import { buildItemListSchema } from "@/utils/schema";

export default function Packages() {
  const itemList = buildItemListSchema(
    PACKAGES.map((p) => ({ name: p.name, description: p.blurb })),
    "/packages"
  );
  return (
    <div data-testid="page-packages" className="bg-[#FAF6F1]">

      <SEO
        title="Event Management Packages — Six Ways to Plan Your Celebration"
        description="Choose from six event management packages — Essential Planning, Signature Event Management, Luxury Wedding Experience, Social Celebration Collection, Corporate Experience Suite, and Devotional Event Suite — or get a custom proposal."
        path="/packages"
        keywords="event management packages, wedding planning package, corporate event package, social celebration package, devotional event package, custom event proposal"
        jsonLd={itemList}
      />
<section className="pt-28 md:pt-32 pb-10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <p className="pill">Packages</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-[84px] leading-[1.0] mt-6 text-[#3B312D] max-w-4xl">
            Six ways to plan your celebration <span className="italic text-[#B65980]">with us</span>.
          </h1>
          <p className="mt-7 max-w-2xl text-[16.5px] text-[#3B312D]/80 leading-relaxed">
            Choose a starting point that fits your event, guest profile, and budget. We will understand your requirements,
            shape the right scope, and share a clear written proposal for your celebration.
          </p>
        </div>
      </section>

      <section className="pb-20 md:pb-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PACKAGES.map((p, i) => (
            <Reveal key={p.name} delay={i * 90}
              className={`relative lux-card p-9 md:p-10 h-full flex flex-col ${i === 1 ? "border-[#B65980] !border-2" : ""}`}>
              {i === 1 && (
                <span className="absolute -top-3 left-9 pill-rose !bg-[#B65980] !text-[#FAF6F1] !border-[#B65980]">
                  <Sparkles size={11} /> Most chosen
                </span>
              )}
              <p className="text-[11px] tracking-[0.24em] uppercase text-[#8A9A7B] font-semibold">{p.tag}</p>
              <h3 className="font-display text-3xl md:text-4xl mt-3 text-[#3B312D]">{p.name}</h3>
              <p className="mt-4 text-[15px] text-[#3B312D]/80 leading-relaxed">{p.blurb}</p>
              <p className="font-display text-2xl mt-6 text-[#B65980]">{p.price}</p>
              <div className="hairline my-7" />
              <ul className="space-y-3 flex-1">
                {p.includes.map((it) => (
                  <li key={it} className="flex items-start gap-3 text-[14.5px] text-[#3B312D]">
                    <Check size={16} className="text-[#8A9A7B] mt-1 shrink-0" /> {it}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className={`mt-9 ${i === 1 ? "btn-primary" : "btn-ghost"} w-fit`} data-testid={`package-cta-${i}`} onClick={() => trackEvent(EVENTS.PACKAGE_INQUIRY_CLICK, { location: "packages-grid", content_name: p.name, content_category: p.tag })}>
                Request Custom Proposal <ArrowRight size={14} />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <BrochureCTA />
      <FinalCTA />
    </div>
  );
}
